import { PropsWithChildren, CSSProperties } from 'react';

import { FlattenSimpleInterpolation } from 'styled-components';

import { CustomCss, CustomInlineStyle } from '@utils/types';

import CheckedIcon from './CheckedIcon';
import { CheckboxContainer, HiddenCheckbox, Label } from './styled';
import { ModeHooks, CheckboxModeType } from './hooks';

export type OutlineSpecsProps = Partial<{
  className: string;
  testid: string;
  labelCss: CustomCss;
  labelStyle: CustomInlineStyle;
  onChange?: (value: boolean) => void;
  LabelComponent?: React.ComponentType<
    React.PropsWithChildren<{
      style?: CSSProperties;
      customCss?: FlattenSimpleInterpolation;
    }>
  >;
  checked: boolean;
  mode?: CheckboxModeType;
  disabled?: boolean;
  outlineColor?: string;
  checkMarkColor?: string;
  checkBackgroundColor?: string;
  checkOnLabelClick?: boolean;
}>;

const CheckboxOutline = ({
  className,
  children,
  testid,
  labelStyle,
  labelCss,
  onChange,
  checked: initialValue,
  LabelComponent = Label,
  mode = 'uncontrolled',
  checkMarkColor,
  outlineColor,
  checkBackgroundColor,
  checkOnLabelClick = true,
  ...rest
}: PropsWithChildren<OutlineSpecsProps>) => {
  const [checked, setChecked] = ModeHooks[mode](initialValue ?? false);
  const onClick = () => {
    setChecked((state) => {
      onChange?.(!state);
      return !state;
    });
  };
  const clickProps = checkOnLabelClick && !rest.disabled ? { onClick } : {};
  return (
    <CheckboxContainer
      className={className}
      data-testid={testid}
      {...clickProps}
    >
      <HiddenCheckbox checked={checked} readOnly {...rest} type='checkbox' />
      <CheckedIcon
        checked={checked}
        checkMarkColor={checkMarkColor}
        outlineColor={outlineColor}
        checkBackgroundColor={checkBackgroundColor}
        onClick={rest.disabled ? undefined : onClick}
      />

      <LabelComponent style={labelStyle} customCss={labelCss}>
        {children}
      </LabelComponent>
    </CheckboxContainer>
  );
};
export default CheckboxOutline;

export { CheckboxContainer };
